import type { FC } from 'react';
import { Box } from '@mui/system';
import CircularProgress from '@mui/material/CircularProgress';
import { memo } from 'react';

interface LoadingContainerProps {
  fullWidth?: boolean;
  height?: number | string;
}

export const LoadingContainer: FC<LoadingContainerProps> = memo(
  ({ fullWidth, height }) => {
    return (
      <Box
        sx={{
          width: fullWidth ? '100%' : 'auto',
          height,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <CircularProgress color="secondary" />
      </Box>
    );
  }
);
